export const SET_ADM_EMAIL_MANAGEMENT_LOADING="SET_ADM_EMAIL_MANAGEMENT_LOADING"
export const SET_ADM_EMAIL_MANAGEMENT_SUCCESS="SET_ADM_EMAIL_MANAGEMENT_SUCCESS"
export const SET_ADM_EMAIL_MANAGEMENT_ERROR="SET_ADM_EMAIL_MANAGEMENT_ERROR"
export const SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE="SET_ADM_EMAIL_MANAGEMENT_ALERT_MESSAGE"
export const GET_DPP_YN="GET_DPP_YN"
export const GET_DPP_YN_SUCCESS="GET_DPP_YN_SUCCESS"
export const UPDATE_DPP_YN="UPDATE_DPP_YN"
export const UPDATE_DPP_YN_SUCCESS="UPDATE_DPP_YN_SUCCESS"
